import { Itinerary } from './../itineray.model';
import { ItineraryExpensesCalculatorService } from './../itinerary-expenses-calculator.service';
import { ActivatedRoute } from "@angular/router";

import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-itinerary-expenses",
  templateUrl: "./itinerary-expenses.component.html",
  styleUrls: ["./itinerary-expenses.component.css"]
})
export class ItineraryExpensesComponent implements OnInit {

  itinerary: Itinerary;

  constructor(private route: ActivatedRoute, private expensesCalculator: ItineraryExpensesCalculatorService) { }

  ngOnInit() {
    this.itinerary = this.route.parent.snapshot.data.itinerary;
    this.expensesCalculator.calulate(this.itinerary);
  }

}
